import React from 'react';

import { SisternodeOutlined } from '@ant-design/icons';

import Messages from 'i18n/messages/home';

import {
  ButtonSmallIcon,
  ContainerButton,
  ItemButton,
} from 'common/components';

import { useGlobalModal } from 'hooks';

import './AddProductToNewApl.less';

const AddProductToNewApl = ({ selectedItemList }) => {
  const { MODAL_NAMES, openModal } = useGlobalModal();

  return (
    <ContainerButton>
      <ItemButton>
        <ButtonSmallIcon
          icon={<SisternodeOutlined style={{ height: 26 }} />}
          label={Messages.addProductToNewApl}
          onClick={() => openModal(MODAL_NAMES.ADD_TO_APL)}
          className='button-item-dropdown'
          disabled={selectedItemList && selectedItemList.length === 0}
        />
      </ItemButton>
    </ContainerButton>
  );
};

export default AddProductToNewApl;
